import { useQuery } from "react-query";
import { api } from "utils/api";
import { collectiveKeys } from "./queryKeys";
import type { Collective } from "../types";

const getCollective = (id?: string) =>
  id
    ? api.get<Collective>(`/collective/${id}/details`)
    : Promise.reject(new Error("Invalid collective id"));

const useCollective = (id?: string) =>
  useQuery(collectiveKeys.detail(id), () => getCollective(id), {
    enabled: !!id,
  });

export { useCollective };
